import { Breadcrumb } from 'antd'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'

import { GroupPricesTab } from './components/GroupPricesTab'

export default function UserGroupShowPage() {
  const { id: groupName } = useParams<{ id: string }>()

  if (!groupName) return null

  return (
    <div>
      <Breadcrumb
        style={{ marginBottom: 16 }}
        items={[
          {
            title: <Link to="/user-groups">User Groups</Link>,
          },
          { title: groupName },
        ]}
      />
      <h2 style={{ marginBottom: 24 }}>Group: {groupName}</h2>

      <GroupPricesTab groupName={groupName} />
    </div>
  )
}
